import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentMethodSection = ({ subscription, onManageSubscription }) => {
  const hasPaymentMethod = subscription?.stripeCustomerId;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-gray-900 mb-1">Payment Method</h2>
          <p className="text-sm text-gray-600">Manage your payment methods and billing information</p>
        </div>
      </div>

      {hasPaymentMethod ? (
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-white rounded-lg border border-gray-200">
              <Icon name="CreditCard" className="w-6 h-6 text-gray-700" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">Payment method on file</p>
              <p className="text-xs text-gray-600">Managed through Stripe</p>
            </div>
          </div>
          <button
            onClick={onManageSubscription}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-white border border-blue-200 rounded-lg hover:bg-blue-50 transition-colors"
          >
            <Icon name="Edit" className="w-4 h-4" />
            Update
          </button>
        </div>
      ) : (
        <div className="text-center py-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
            <Icon name="CreditCard" className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No payment method</h3>
          <p className="text-gray-600 mb-4">Add a payment method to upgrade to Pro</p>
          <button
            onClick={() => window.location.href = '/pricing-plans'}
            className="inline-flex items-center gap-2 px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Icon name="Plus" className="w-4 h-4" />
            Upgrade to Pro
          </button>
        </div>
      )}

      {/* Security Notice */}
      <div className="mt-6 flex items-start gap-3 p-4 bg-blue-50 rounded-lg">
        <Icon name="Shield" className="w-5 h-5 text-blue-600 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-medium text-blue-900 mb-1">Secure Payment Processing</p>
          <p className="text-xs text-blue-700">
            All payment information is securely processed and stored by Stripe. We never store your full card details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodSection;